import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Commission {
  teacher_id: string;
  teacher_name: string | null;
  student_id: string;
  student_name: string | null;
  teaching_ratio: number;
  teacher_specific_sessions: number;
  total_sessions: number;
  course_cost: number;
  total_hours_purchased: number;
  commission_amount: number;
  enrollment_date: string | null;
  month: number;
  year: number;
  created_at: string;
}

export function useCommissions(month: number, year: number) {
  return useQuery({
    queryKey: ['commissions', month, year],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('commissions')
        .select('*')
        .eq('month', month)
        .eq('year', year)
        .order('teacher_name', { ascending: true });

      if (error) throw error;
      return data as Commission[];
    },
  });
}
